<template>
  <div>
    <b-field v-if="title">
      <div class="mgl-10px has-text-weight-bold mg-auto">{{ title }} </div>
      <div v-if="!isAlreadySelect">
        <button class="button is-size-7" @click="clearSelection">
          {{ $t('general.select.clearSelection') }}
        </button>
      </div>
    </b-field>
    <div v-if="info" class="has-text-centered has-text-icon-more mgt-20px">
      {{ info }}
    </div>
    <div v-for="(select, index) in selection" :key="index">
      <div class="mgt-10px has-background-background">
        <div class="columns is-vcentered shadow is-marginless">
          <div class="column mgl-10px is-paddingless">
            <b-field class="mgb-0">
              <p class="has-text-link is-size-6 ellipsis has-text-weight-bold textPanier">
                {{ select.libelle }}
              </p>
              <b-icon v-if="isAlreadySelect"
                      icon="bookmark-check"
                      type="is-link" size="is-small" class="mgv-auto">
              </b-icon>
            </b-field>
            <p class="has-text-default is-size-7 ellipsis textPanier">
              {{ formatageDatePeriode(select.dateDebut, select.dateFin)}}
            </p>
          </div>
          <div class="column is-narrow">
            <a @click="makeDelete(index)">
              <b-icon
                icon="delete-forever"
                type='is-danger'>
              </b-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import formatDate from '@/services/general/formatDate';

const Produit = createNamespacedHelpers('produit');

export default {
  props: {
    selection: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
    info: {
      type: String,
      required: false,
    },
    isAlreadySelect: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...Produit.mapGetters({
      selectionGetter: 'selection',
    }),
  },
  methods: {
    ...Produit.mapActions({
      deleteProduit: 'deleteLiaisonTarifInSelection',
    }),
    formatageDatePeriode(dateDebut, dateFin) {
      if (dateDebut === dateFin) return formatDate(dateDebut);
      return this.$t('general.datePeriode', { dateDebut: formatDate(dateDebut), dateFin: formatDate(dateFin) });
    },
    makeDelete(index) {
      this.deleteProduit({ index: index, isAlreadySelect: this.isAlreadySelect });
    },
    clearSelection() {
      const selection = cloneDeep(this.selectionGetter.filter((produit) => {
        return produit.isAlreadySelect;
      }));
      for (let i = 0; i < selection.length; i += 1) this.makeDelete(i);
    },
  },
};

</script>
